import React from "react";
import { useInformeBySlug } from "../../hooks/useWordPressData";
import useCurrentSlug from "../../hooks/useCurrentSlug";
import { useContext } from "react";
import { LangContext } from "../../context/DataContext";
import Spinner from "../common/spinner/Spinner";

// Función para generar un slug limpio para las anclas
const generateAnchorSlug = (text) => {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "") // Remover caracteres especiales
    .replace(/\s+/g, "-") // Reemplazar espacios con guiones
    .replace(/-+/g, "-") // Reemplazar múltiples guiones con uno solo
    .trim();
};

const DynamicReportContentAutoSlug = ({ fallbackSlug = null }) => {
  const { myLang } = useContext(LangContext);
  const currentSlug = useCurrentSlug();
  
  // Usar el slug actual de la URL, o el fallback si no hay slug en la URL
  const slug = currentSlug || fallbackSlug; 
  
  const { informe, loading, error, hasData } = useInformeBySlug(slug, true, myLang);
  
  // Renderizar información del informe
  const renderInformacion = () => {
    if (!informe?.informacion) return null;

    const { autor, coordinacion, edicion, area, fecha, version, archivo } =
      informe.informacion;

    return (
      <div className="alerts alert_white">
        <p>
          <strong> Autor:</strong> {autor}
        </p>

        {coordinacion && (
          <p>
            <strong>Coordinación:</strong> {coordinacion}
          </p>
        )}
        {edicion && (
          <p>
            <strong>Edición:</strong> {edicion}
          </p>
        )}
        {area && (
          <p>
            <strong>Área:</strong> {area}
          </p>
        )}
        {fecha && (
          <p>
            <strong>Fecha:</strong> {fecha}
          </p>
        )}
        {version && (
          <p>
            <strong>Versión:</strong> {version}
          </p>
        )}
        {archivo && (
          <a
            href={archivo}
            className="buttons button_blue"
            rel="noopener noreferrer"
            target="_blank"
          >
            Descargar PDF
          </a>
        )}
      </div>
    );
  };

   

  // Renderizar todas las secciones con anclas
  const renderSecciones = () => {
    if (!informe?.secciones) return null;

    return informe.secciones.map((seccion, index) => {
      const sectionAnchor = generateAnchorSlug(seccion.titulo);

      return (
        <section key={index} id={sectionAnchor} className="report-section">
          <h2 className="section-title">{seccion.titulo}</h2>
          <div
            className="section-content"
            dangerouslySetInnerHTML={{ __html: seccion.contenido }}
          />

          {/* Renderizar subsecciones si existen */}
          {seccion.subsecciones && Array.isArray(seccion.subsecciones) && seccion.subsecciones.length > 0 && (
            <div className="subsecciones-container">
              {seccion.subsecciones.map((subseccion, subIndex) => {
                const subSectionAnchor = generateAnchorSlug(
                  subseccion.titulo_de_la_subseccion
                );

                return (
                  <div
                    key={subIndex}
                    id={subSectionAnchor}
                    className="subseccion"
                  >
                    <h3 className="subseccion-title">
                      {subseccion.titulo_de_la_subseccion}
                    </h3>
                    <div
                      className="subseccion-content"
                      dangerouslySetInnerHTML={{
                        __html: subseccion.contenido_de_la_subseccion,
                      }}
                    />
                  </div>
                );
              })}
            </div>
          )}
        </section>
      );
    });
  };

  // Estado de carga
  if (loading) {
    return (
      <div className="loading-container">
        <Spinner
          size="large"
          color="primary"
          text={`Cargando informe en ${myLang}...`}
          showText={true}
          variant="rings"
        />
         
      </div>
    );
  }

  // Estado de error
  if (error) {
    return (
      <div className="error-container">
       
        
      </div>
    );
  }

  // Si no hay datos, mostrar mensaje
  if (!hasData) {
    return (
      <div className="not-found-container">
        
      </div>
    );
  }

  // Contenido principal
  return (
    <div className="dynamic-report-content">
       
      <div className="report-header">
        <h1>{informe.title}</h1>
        {renderInformacion()}
      </div>

      <main className="report-main">
        <div id="report-content" className="report-sections">
          {renderSecciones()}
        </div>
      </main>
    </div>
  );
};

export default DynamicReportContentAutoSlug;
